export const VIEWS = {
  INITIAL_VIEW: 'INITIAL_VIEW',
  EMAIL_LOGIN_VIEW: 'EMAIL_LOGIN_VIEW',
  RESET_PASSWORD_VIEW: 'RESET_PASSWORD_VIEW',
  RESET_PASSWORD_LINK_SENT_VIEW: 'RESET_PASSWORD_LINK_SENT_VIEW',
  CREATE_ACCOUNT_VIEW: 'CREATE_ACCOUNT_VIEW',
  CREATE_ACCOUNT_SUCCESS_VIEW: 'CREATE_ACCOUNT_SUCCESS_VIEW'
};
